import * as React from 'react';
import { useState } from 'react';

import { IconButton } from '@mui/material';
import { NavLink, useLocation } from 'react-router-dom';

import { TydeMenuItemProps } from './TydeMenuItemProps';

import './tyde-menu-item.scss';

export function TydeMenuItem(props: TydeMenuItemProps) {
  const { item } = props;

  [item.state, item.setState] = useState({ hovered: false });
  const location = useLocation();

  const menuItemEnter = () => {
    item.setState?.({ hovered: true });
  };

  const menuItemLeave = () => {
    item.setState?.({ hovered: false });
  };

  const menuItemClick = () => {
    item.clickHandler?.(item);
  };

  const showPopover = item.state.hovered && !props.menuState.expanded;

  const activeElement = (
    <div className="active-container">
      <div className="active" />
    </div>
  );

  const popoverElement = <div className="popover-title">{item.title}</div>;

  const titleElement = <div className="title">{item.title}</div>;

  const popover = showPopover ? popoverElement : '';
  const title = props.menuState.expanded ? titleElement : '';
  const active = location.pathname === item.route ? activeElement : undefined;

  return (
    <NavLink
      to={item.route}
      reloadDocument={false}
      className={`tyde-menu-item ${props.className}`}
      onMouseEnter={menuItemEnter}
      onMouseLeave={menuItemLeave}
      onClick={menuItemClick}
      state={item}
    >
      {popover}
      <div className="icon">
        <IconButton>{item.icon(null)}</IconButton>
      </div>
      {title}
      {active}
    </NavLink>
  );
}
